const triggerDownload = (blobData: Blob, fileTitle: string, extension = 'csv'): void => {
  // a little hacky, but needed to download the file
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(new Blob([blobData]));
  link.download = `${fileTitle}.${extension}`;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const triggerURIDownload = (content: string, fileTitle: string): void => {
  const encodedUri = encodeURI(content);
  const link = document.createElement('a');
  link.href = encodedUri;
  link.download = `${fileTitle}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export default triggerDownload;
